const filterGuests = (guestList, searchTerm) => {
    const filtered = guestList.filter((guest) =>
      guest.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return [...new Set(filtered)];
  };
  
  export default filterGuests;
  